import { render, staticRenderFns } from "./le-switch.vue?vue&type=template&id=7d34bcf4&"
import script from "./le-switch.vue?vue&type=script&lang=js&"
export * from "./le-switch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports